import { IUser } from "../pages/models/IUser";
import { makeAutoObservable } from "mobx";
import AuthService from "../services/AuthService";
import { toast } from "react-toastify";
import { setStudentToken } from "../http/index"; // SEC #8: in-memory token setter


export default class Store {
    user = {} as IUser;
    isAuth = false;
    isLoading = false;
    haveNote = false;
    lastActivityTime: number = 0;

    setLastActivityTime(currentTime: number) {
        this.lastActivityTime = currentTime;
    }

    constructor() {
        makeAutoObservable(this);
        this.loadSessionData();
    }


    setAuth(bool: boolean) {
        this.isAuth = bool;
        sessionStorage.setItem("isAuthUser", JSON.stringify(bool));
    }

    setUser(user: IUser) {
        this.user = user;
        sessionStorage.setItem("user", JSON.stringify(user));
    }



    setLoading(bool: boolean) {
        this.isLoading = bool;
    }

    setHaveNote(value: boolean) {
        this.haveNote = value;
    }



    loadSessionData() {
        const storedUser = sessionStorage.getItem("user");
        const storedIsAuth = sessionStorage.getItem("isAuthUser");

        if (storedUser) {
            this.user = JSON.parse(storedUser);
        }
        if (storedIsAuth) {
            this.isAuth = JSON.parse(storedIsAuth);
        }
    }

    async login(email: string, password: string) {
        try {
            const response = await AuthService.login(email, password, { withCredentials: true });
            setStudentToken(response.data.accessToken); // SEC #8: memory only, not sessionStorage
            this.setAuth(true);
            this.setUser(response.data.user);
            toast.success(`Välkommen ${response.data.user.name}`);
        } catch (error) {
            // @ts-ignore
            if (error.response && error.response.status === 429) {
                throw error;
            } else {
                // @ts-ignore
                toast.error(error.response?.data?.message || "Login failed");
            }
        } finally {
            this.setLoading(false);
        }
    }



    async googleLogin(authCode: string) {
        try {
            const response = await AuthService.googleLogin(authCode, { withCredentials: true });
            setStudentToken(response.data.accessToken); // SEC #8: memory only, not sessionStorage
            this.setAuth(true);
            this.setUser(response.data.user);
            toast.success(`Welcome ${response.data.user.name}`);
            return response.data; // This now includes profileComplete and user info
        } catch (error: any) { // Explicitly type error or use unknown
            toast.error(error.response?.data?.message || "Google login failed");
            throw error; // Ensure errors are propagated
        }
    }



    async changepass(password: string, studentId: string, restoreToken: any) {
        try {
            await AuthService.pass(password, studentId, restoreToken, { withCredentials: true });
            // SEC #9: removed localStorage.setItem('restoreToken', ...) — server returns "Done!" not a token
            // localStorage persists across sessions and is readable by XSS
            window.location.reload();

        } catch (e) {
            // @ts-ignore
            toast.error(e.response?.data?.message)
        }
    }

    async checkRest(restoreToken: string) {
        try {
            const response = await AuthService.checkRest(restoreToken,{ withCredentials: true }) ;
            // Assuming the response indicates success or failure
            if (response.data.success) {
                return true;
            } else {
                throw new Error("Invalid or expired token");
            }
        } catch (e) {
            // @ts-ignore
            throw new Error(e.response?.data?.message || "Failed to validate token");
        }
    }


    async checkAuth() {
        try {
            const response = await AuthService.checkAuth();
            setStudentToken(response.data.accessToken); // SEC #8: memory only
            this.setAuth(true);
            this.setUser(response.data.user);
        } catch (e) {
            this.setAuth(false);
            this.setUser({} as IUser);
        }
    }

    async recover(email: string) {
        try {
            await AuthService.recover(email);
        } catch (e) {

        }
    }

    async registration(name: string, email: string, password: string, city: string, category: string[]) {
        try {
            const response = await AuthService.registration(name, email, password, city, category, { withCredentials: true });
            // @ts-ignore
            return { status: 200 };
        } catch (error) {

            // @ts-ignore
            toast.error(error.response?.data?.message);
        }
    }


    async registrationG(name: string, city: string, studentId: string, category: string[], autotransmission: boolean) {
        try {
            const response = await AuthService.registrationG(name, city,  studentId, category, autotransmission,{ withCredentials: true });
            // @ts-ignore
            return { status: 200 };
        } catch (error) {

            // @ts-ignore
            toast.error(error.response?.data?.message);
        }
    }


    async logout() {
        try {
            const response = await AuthService.logout();
            this.setAuth(false);
            this.setUser({} as IUser);
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('user');
            sessionStorage.removeItem('isAuthUser');
            sessionStorage.clear();
            toast.success("Log out complete")
        } catch (e) {
            // @ts-ignore

            toast.error(e.response?.data?.message)
        }
    }



}



